import ECGReportManagementLayer from "../components/ECGReportManagementLayer";

const ECGReportManagementPage = () => {
  return <ECGReportManagementLayer />;
};

export default ECGReportManagementPage;
